export const apiKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweGJDNjJhZUQ4YTg4QWY2NjhmMGE0RGY1NzY3RWJENGQxRjRmYjM2MTQiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY1NzU2ODIxNzg2OSwibmFtZSI6IkVtcGxveW1lbnQtUmVmZXJlbmNlIn0.B9ml9Y4ZCW7YdNGhwteT_gpyPpB3GdeY3bTgo9Tu8zQ'
